import _objectDestructuringEmpty from "@babel/runtime/helpers/objectDestructuringEmpty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useState, useEffect } from 'react';
import { Modal, ModalHeader, ModalBody } from '../../Modal';
import defaultClasses from './tearsheetModal.module.css';
import { useAppContext } from '@magento/peregrine/lib/context/app';
import { Form } from 'informed';
import TearsheetForm from './tearsheetForm/tearsheetForm';
import classes from './tearsheetModal.module.css';
import { removeScrollFromBody, addScrollToBody } from '../../../hooks/utils';

var TearsheetModal = function TearsheetModal(_ref) {
  var isOpen = _ref.isOpen,
      onSubmitFn = _ref.onSubmitFn;

  var _useAppContext = useAppContext(),
      _useAppContext2 = _slicedToArray(_useAppContext, 2);

  _objectDestructuringEmpty(_useAppContext2[0]);

  var closeDrawer = _useAppContext2[1].closeDrawer;

  var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      showPrice = _useState2[0],
      setShowPrice = _useState2[1];

  var onFormSubmit = function onFormSubmit(values) {
    return onSubmitFn && onSubmitFn(values);
  };

  useEffect(function () {
    removeScrollFromBody();
    return function () {
      return addScrollToBody();
    };
  }, [isOpen]);
  return React.createElement(React.Fragment, null, React.createElement(Modal, {
    isOpen: isOpen,
    toggleModal: closeDrawer,
    classes: {
      modalWrapper: classes.modalWrapper
    }
  }, React.createElement(ModalHeader, {
    title: "Download Tearsheet",
    classes: {
      root: 'text-22 py-6 text-white bg-bronze px-8'
    },
    closeModal: closeDrawer
  }), React.createElement(ModalBody, null, React.createElement("div", {
    className: defaultClasses.root
  }, React.createElement(Form, {
    onSubmit: onFormSubmit
  }, React.createElement(TearsheetForm, {
    closeDrawer: closeDrawer,
    showPrice: showPrice,
    setShowPrice: setShowPrice
  }))))));
};

export default TearsheetModal;